<template>
  <SinglePage>
    <div class="cpj-singlePageWrapper">
      <h1>Site map</h1>
      <div v-for="(item,idx) in siteMapList" :key="item.key">
        <div class="site-map-block" v-if="item.title !== 'Career Advice'">
          <h3>{{ item.title }}</h3>
          <div :key="idx" class="row">
            <div v-for="i in item.list" :key="i.link" class="col-xs-12 col-md-6 col-lg-4 ">
              <a :href="i.link">{{ i.text }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SinglePage>
</template>

<script>
import SinglePage from '../components/global/SinglePage'
import json from '../components/sitemap.json'
export default {
  components: {
    SinglePage
  },
  data: function () {
    return {
      siteMapList: json
    }
  }
}
</script>

<style>
  .cpj-singlePageWrapper {
    line-height: 23px;
  }
.site-map-block{
  margin-bottom: 32px;
}
  h3 {
    font-size: 17px;
    color: #707070;
    font-weight: bold;
  }
  .cpj-singlePageWrapper  a{
    display: list-item;          /* This has to be "list-item"                                               */
    list-style-type: disc;       /* See https://developer.mozilla.org/en-US/docs/Web/CSS/list-style-type     */
    list-style-position: inside;
    color:#2B59C3;
    font-size: 14px;
    line-height: 32px;
  }
</style>
